var B = Object.defineProperty;
var H = (t, e, o) => e in t ? B(t, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : t[e] = o;
var I = (t, e, o) => (H(t, typeof e != "symbol" ? e + "" : e, o), o);
import { utils as p, BaseDocument as v, applyMixins as G, actions as J } from "document-model/document";
import { z as n } from "./document-models/account-snapshot.js";
const Y = {
  id: "makerdao/scope-framework",
  name: "ScopeFramework",
  extension: "mdsf",
  description: "The MakerDAO Scope Framework document contains articles, sections and other elements that make up the governance rules for the MakerDAO scopes.",
  author: {
    name: "MakerDAO",
    website: "https://www.makerdao.com/"
  },
  specifications: [
    {
      version: 1,
      changeLog: [],
      modules: [
        {
          name: "main",
          operations: [
            {
              name: "SetRootPath",
              id: "",
              description: "",
              schema: `type SetRootPathInput {
    newRootPath: String!
}`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            },
            {
              name: "AddElement",
              id: "",
              description: "",
              schema: `type AddElementInput {
    id: String!
    path: String!
    type: ScopeFrameworkElementType!
    name: String
    components: ElementComponents
}`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            },
            {
              name: "UpdateElementType",
              id: "",
              description: "",
              schema: `type UpdateElementTypeInput {
    id: ID!
    type: ScopeFrameworkElementType!
}`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            },
            {
              name: "UpdateElementName",
              id: "",
              description: "",
              schema: `type UpdateElementNameInput {
    id: ID!
    name: String
}`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            },
            {
              name: "UpdateElementComponents",
              id: "",
              description: "",
              schema: `type UpdateElementComponentsInput {
    id: ID!
    components: ElementComponents
}`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            },
            {
              name: "RemoveElement",
              id: "",
              description: "",
              schema: `type RemoveElementInput {
    id: ID!
}`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            },
            {
              name: "ReorderElements",
              id: "",
              description: "",
              schema: `type ReorderElementsInput {
    parentElementId: ID!
    order: [ID!]!
}`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            },
            {
              name: "MoveElement",
              id: "",
              description: "",
              schema: `type MoveElementInput {
    id: ID!
    newParentId: ID!
}`,
              template: "",
              reducer: "",
              examples: [],
              errors: [],
              scope: "global"
            }
          ],
          id: "",
          description: ""
        }
      ],
      state: {
        global: {
          schema: `type ScopeComponent {
    content: String
}
                    
type  ArticleComponent {
    content: String
}
                    
type  SectionComponent {
    content: String
}
                    
type  CoreComponent {
    content: String
}
                    
enum TypeSpecificationComponentCategory {
    Primary
    Supporting
    Immutable
    Accessory
}
                    
type  TypeSpecificationComponent {
    name: String
    overview: String
    category: TypeSpecificationComponentCategory
    documentIdentifierRules: String
    typeAuthority: String
    additionalLogic: String
}
                    
union ElementComponents = 
        ScopeComponent
    |   ArticleComponent
    |   SectionComponent
    |   CoreComponent
    |   TypeSpecificationComponent
                    
enum ScopeFrameworkElementType {
    Scope
    Article
    Section
    Core
    TypeSpecification
}
                    
type  ScopeFrameworkElement {
    id: ID!
    path: String!
    version: Int!
    name: String
    type: ScopeFrameworkElementType
    components: ElementComponents
}
                    
type  ScopeFrameworkState {
    rootPath: String!
    elements: [ScopeFrameworkElement!]!
}`,
          initialValue: '"{\\n    \\"rootPath\\": \\"A\\",\\n    \\"elements\\": [\\n        {\\n            \\"id\\": \\"hruFam5ot7s0Gb1n+aIBa+y+NJA=\\",\\n            \\"name\\": \\"Scope Name\\",\\n            \\"version\\": 1,\\n            \\"type\\": \\"Scope\\",\\n            \\"path\\": \\"A.1\\",\\n            \\"components\\": {\\n                \\"content\\": \\"Scope description goes here.\\"\\n            }\\n        }\\n    ]\\n}"',
          examples: []
        },
        local: {
          schema: "type ScopeFrameworkLocalState",
          initialValue: '"{}"',
          examples: []
        }
      }
    }
  ]
}, A = (t) => t != null, Q = n.any().refine((t) => A(t)), E = n.enum(["Article", "Core", "Scope", "Section", "TypeSpecification"]), P = n.enum(["Accessory", "Immutable", "Primary", "Supporting"]);
function S() {
  return n.object({
    __typename: n.literal("AddElementInput").optional(),
    components: h().nullable(),
    id: n.string(),
    name: n.string().nullable(),
    path: n.string(),
    type: E
  });
}
function O() {
  return n.object({
    __typename: n.literal("ArticleComponent").optional(),
    content: n.string().nullable()
  });
}
function F() {
  return n.object({
    __typename: n.literal("CoreComponent").optional(),
    content: n.string().nullable()
  });
}
function h() {
  return n.union([O(), F(), R(), M(), k()]);
}
function y() {
  return n.object({
    __typename: n.literal("MoveElementInput").optional(),
    id: n.string(),
    newParentId: n.string()
  });
}
function g() {
  return n.object({
    __typename: n.literal("RemoveElementInput").optional(),
    id: n.string()
  });
}
function b() {
  return n.object({
    __typename: n.literal("ReorderElementsInput").optional(),
    order: n.array(n.string()),
    parentElementId: n.string()
  });
}
function R() {
  return n.object({
    __typename: n.literal("ScopeComponent").optional(),
    content: n.string().nullable()
  });
}
function N() {
  return n.object({
    __typename: n.literal("ScopeFrameworkElement").optional(),
    components: h().nullable(),
    id: n.string(),
    name: n.string().nullable(),
    path: n.string(),
    type: E.nullable(),
    version: n.number()
  });
}
function W() {
  return n.object({
    __typename: n.literal("ScopeFrameworkLocalState").optional()
  });
}
function Z() {
  return n.object({
    __typename: n.literal("ScopeFrameworkState").optional(),
    elements: n.array(N()),
    rootPath: n.string()
  });
}
function M() {
  return n.object({
    __typename: n.literal("SectionComponent").optional(),
    content: n.string().nullable()
  });
}
function f() {
  return n.object({
    __typename: n.literal("SetRootPathInput").optional(),
    newRootPath: n.string()
  });
}
function k() {
  return n.object({
    __typename: n.literal("TypeSpecificationComponent").optional(),
    additionalLogic: n.string().nullable(),
    category: P.nullable(),
    documentIdentifierRules: n.string().nullable(),
    name: n.string().nullable(),
    overview: n.string().nullable(),
    typeAuthority: n.string().nullable()
  });
}
function _() {
  return n.object({
    __typename: n.literal("UpdateElementComponentsInput").optional(),
    components: h().nullable(),
    id: n.string()
  });
}
function T() {
  return n.object({
    __typename: n.literal("UpdateElementNameInput").optional(),
    id: n.string(),
    name: n.string().nullable()
  });
}
function w() {
  return n.object({
    __typename: n.literal("UpdateElementTypeInput").optional(),
    id: n.string(),
    type: E
  });
}
const se = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AddElementInputSchema: S,
  ArticleComponentSchema: O,
  CoreComponentSchema: F,
  ElementComponentsSchema: h,
  MoveElementInputSchema: y,
  RemoveElementInputSchema: g,
  ReorderElementsInputSchema: b,
  ScopeComponentSchema: R,
  ScopeFrameworkElementSchema: N,
  ScopeFrameworkElementTypeSchema: E,
  ScopeFrameworkLocalStateSchema: W,
  ScopeFrameworkStateSchema: Z,
  SectionComponentSchema: M,
  SetRootPathInputSchema: f,
  TypeSpecificationComponentCategorySchema: P,
  TypeSpecificationComponentSchema: k,
  UpdateElementComponentsInputSchema: _,
  UpdateElementNameInputSchema: T,
  UpdateElementTypeInputSchema: w,
  definedNonNullAnySchema: Q,
  isDefinedNonNullAny: A
}, Symbol.toStringTag, { value: "Module" })), C = (t) => t.split(".", 2)[0], q = (t, e) => {
  const o = t.split("."), r = e.split("."), l = Math.min(o.length, r.length);
  if (o[0] != r[0])
    return o[0] < r[0];
  for (let a = 1; a < l; a++)
    if (o[a] != r[a])
      return parseInt(o[a]) < parseInt(r[a]);
  return o.length < r.length;
}, i = {
  setRootPathOperation(t, e) {
    const o = /^[A-Z]+$/;
    if (!e.input.newRootPath.match(o))
      throw new Error(
        `Invalid root path format ${e.input.newRootPath}. Use one or more capital letters: 'A', 'D', 'AQ', ...`
      );
    const r = t.rootPath + ".", l = e.input.newRootPath + ".";
    t.rootPath = e.input.newRootPath, t.elements = t.elements.map((a) => ({
      ...a,
      path: a.path.replace(r, l)
    }));
  },
  addElementOperation(t, e) {
    const o = [], r = {
      id: e.input.id,
      version: 1,
      path: e.input.path,
      type: e.input.type,
      name: e.input.name,
      components: e.input.components
    };
    if (C(r.path) != t.rootPath)
      throw new Error(
        `Cannot add element with root segment ${C(
          r.path
        )} to document with root path ${t.rootPath}`
      );
    let l = !1, a = null;
    for (; a = t.elements.shift(); ) {
      if (!l && q(r.path, a.path) && (o.push(r), l = !0), !l && r.path == a.path)
        throw new Error(
          `New element's path ${r.path} already exists.`
        );
      o.push(a);
    }
    l || o.push(r), t.elements = o;
  },
  updateElementTypeOperation(t, e) {
    t.elements.filter((o) => o.id == e.input.id).forEach((o) => {
      o.type = e.input.type;
    });
  },
  updateElementNameOperation(t, e) {
    t.elements.filter((o) => o.id == e.input.id).forEach((o) => {
      o.name = e.input.name;
    });
  },
  updateElementComponentsOperation(t, e) {
    t.elements.filter((o) => o.id == e.input.id).forEach((o) => {
      o.components = e.input.components;
    });
  },
  removeElementOperation(t, e) {
    const o = t.elements.filter((r) => r.id == e.input.id)[0];
    o && (t.elements = t.elements.filter(
      (r) => !r.path.startsWith(o.path)
    ));
  },
  reorderElementsOperation(t, e) {
    throw new Error(
      'Reducer "reorderElementsOperation" not yet implemented'
    );
  },
  moveElementOperation(t, e) {
    throw new Error('Reducer "moveElementOperation" not yet implemented');
  }
}, K = (t, e, o) => {
  if (p.isBaseAction(e))
    return t;
  switch (e.type) {
    case "SET_ROOT_PATH":
      f().parse(e.input), i.setRootPathOperation(t[e.scope], e, o);
      break;
    case "ADD_ELEMENT":
      S().parse(e.input), i.addElementOperation(t[e.scope], e, o);
      break;
    case "UPDATE_ELEMENT_TYPE":
      w().parse(e.input), i.updateElementTypeOperation(t[e.scope], e, o);
      break;
    case "UPDATE_ELEMENT_NAME":
      T().parse(e.input), i.updateElementNameOperation(t[e.scope], e, o);
      break;
    case "UPDATE_ELEMENT_COMPONENTS":
      _().parse(e.input), i.updateElementComponentsOperation(t[e.scope], e, o);
      break;
    case "REMOVE_ELEMENT":
      g().parse(e.input), i.removeElementOperation(t[e.scope], e, o);
      break;
    case "REORDER_ELEMENTS":
      b().parse(e.input), i.reorderElementsOperation(t[e.scope], e, o);
      break;
    case "MOVE_ELEMENT":
      y().parse(e.input), i.moveElementOperation(t[e.scope], e, o);
      break;
    default:
      return t;
  }
}, c = p.createReducer(K), X = {
  rootPath: "A",
  elements: [
    {
      id: "hruFam5ot7s0Gb1n+aIBa+y+NJA=",
      name: "Scope Name",
      version: 1,
      type: "Scope",
      path: "A.1",
      components: {
        content: "Scope description goes here."
      }
    }
  ]
}, ee = {}, s = {
  fileExtension: "mdsf",
  createState(t) {
    return { global: { ...X, ...t == null ? void 0 : t.global }, local: { ...ee, ...t == null ? void 0 : t.local } };
  },
  createExtendedState(t) {
    return p.createExtendedState(
      { ...t, documentType: "makerdao/scope-framework" },
      s.createState
    );
  },
  createDocument(t) {
    return p.createDocument(
      s.createExtendedState(t),
      s.createState
    );
  },
  saveToFile(t, e, o) {
    return p.saveToFile(t, e, "mdsf", o);
  },
  saveToFileHandle(t, e) {
    return p.saveToFileHandle(t, e);
  },
  loadFromFile(t) {
    return p.loadFromFile(t, c);
  },
  loadFromInput(t) {
    return p.loadFromInput(t, c);
  }
}, { createAction: m } = p, D = (t) => m(
  "SET_ROOT_PATH",
  { ...t },
  void 0,
  f,
  "global"
), x = (t) => m(
  "ADD_ELEMENT",
  { ...t },
  void 0,
  S,
  "global"
), j = (t) => m(
  "UPDATE_ELEMENT_TYPE",
  { ...t },
  void 0,
  w,
  "global"
), L = (t) => m(
  "UPDATE_ELEMENT_NAME",
  { ...t },
  void 0,
  T,
  "global"
), U = (t) => m(
  "UPDATE_ELEMENT_COMPONENTS",
  { ...t },
  void 0,
  _,
  "global"
), $ = (t) => m(
  "REMOVE_ELEMENT",
  { ...t },
  void 0,
  g,
  "global"
), z = (t) => m(
  "REORDER_ELEMENTS",
  { ...t },
  void 0,
  b,
  "global"
), V = (t) => m(
  "MOVE_ELEMENT",
  { ...t },
  void 0,
  y,
  "global"
);
class te extends v {
  setRootPath(e) {
    return this.dispatch(D(e));
  }
  addElement(e) {
    return this.dispatch(x(e));
  }
  updateElementType(e) {
    return this.dispatch(j(e));
  }
  updateElementName(e) {
    return this.dispatch(L(e));
  }
  updateElementComponents(e) {
    return this.dispatch(U(e));
  }
  removeElement(e) {
    return this.dispatch($(e));
  }
  reorderElements(e) {
    return this.dispatch(z(e));
  }
  moveElement(e) {
    return this.dispatch(V(e));
  }
}
const d = class d extends v {
  constructor(e, o) {
    super(c, s.createDocument(e), o);
  }
  saveToFile(e, o) {
    return super.saveToFile(e, d.fileExtension, o);
  }
  loadFromFile(e) {
    return super.loadFromFile(e);
  }
  static async fromFile(e) {
    const o = new this();
    return await o.loadFromFile(e), o;
  }
};
I(d, "fileExtension", "mdsf");
let u = d;
G(u, [
  te
]);
const ne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addElement: x,
  moveElement: V,
  removeElement: $,
  reorderElements: z,
  setRootPath: D,
  updateElementComponents: U,
  updateElementName: L,
  updateElementType: j
}, Symbol.toStringTag, { value: "Module" })), oe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), re = u, ae = { ...s, ...oe }, pe = { ...J, ...ne }, ce = {
  Document: re,
  reducer: c,
  actions: pe,
  utils: ae,
  documentModel: Y
};
export {
  re as Document,
  u as ScopeFramework,
  pe as actions,
  Y as documentModel,
  ce as module,
  c as reducer,
  ae as utils,
  se as z
};
